import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import InputEditor from '@components/UI-Components/InputEditor'
import useOrderContext from '@modules/order/hooks/use-order-context'
import useViewContext from '@modules/order/hooks/use-view-context'
import { PRODUCT_OPERATIONS_LOADERS } from '@modules/order/stores/view/List/ListDataStore'
import { ListUIStore } from '@modules/order/stores/view/List/ListUIStore'
import { hasUserRoles } from '@services/userRoleService'
import get from 'lodash/get'
import isNumber from 'lodash/isNumber'
import { useObserver } from 'mobx-react-lite'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import Cell from '../../components/Cell'

const Comment: ({ commentType, allowedUserRoles }) => FC<CellItem> =
  ({ commentType, allowedUserRoles }) =>
  ({ rowData, column }) =>
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useObserver(function useHook() {
      const {
        uiStore: { isOrderEditable }
      } = useOrderContext()
      const { t } = useTranslation()
      const viewContextValue = useViewContext()
      if (!rowData) {
        return <></>
      }
      const { updateComment, dataStore } = viewContextValue.uiStore as ListUIStore
      const value = get(rowData, column.field)
      const index = rowData?.id
        ? dataStore.itemIndexObjectStore.getIndexByKey(rowData.id)
        : null
      const disabled = isNumber(index)
        ? dataStore.itemIndexObjectStore.isObjectsDataLoading(
            index,
            index + 1,
            `${PRODUCT_OPERATIONS_LOADERS.UPDATING_DRAFT_QUANTITY}_${commentType}`
          ) || !hasUserRoles(allowedUserRoles)
        : false
      return (
        <Cell>
          <InputEditor
            disabled={disabled || !rowData?.original?.active || !isOrderEditable}
            header={t('order.rmComment.placeholder', 'Edit Comment')}
            onChange={value => updateComment(rowData.id, value, commentType)}
            placeholder={!disabled && t('order.rmComment.placeholder', 'Edit Comment')}
            value={value}
            className={'CM' === commentType ? { typography: 'clearText' } : {}}
          />
        </Cell>
      )
    })

export default Comment
